var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterOutline(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.257 7.3l23.524 29.569a7.327 7.327 0 011.59 4.562V65.7l7.258-5.475V41.428c0-1.657.56-3.265 1.59-4.56L64.743 7.3H7.257zm0-7.3h57.486c1.367 0 2.707.389 3.864 1.121a7.286 7.286 0 012.677 3.018 7.335 7.335 0 01-.876 7.724l-23.52 29.565v18.797a7.335 7.335 0 01-.767 3.265 7.29 7.29 0 01-2.137 2.575l-7.258 5.475a7.222 7.222 0 01-7.6.69 7.274 7.274 0 01-2.93-2.692 7.332 7.332 0 01-1.083-3.838V41.427L1.593 11.864A7.337 7.337 0 01.715 4.14 7.286 7.286 0 013.393 1.12 7.228 7.228 0 017.257 0z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOutline);
export default ForwardRef;